import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { take } from 'rxjs/operators';
import firebase from 'firebase/compat/app';

@Injectable({
  providedIn: 'root',
})
export class UserProfileService {
  constructor(private firestore: AngularFirestore) {}

  getProfile(userID) {
    return this.firestore.collection('Users').doc(userID).get();
  }

  getCallerProfile(phoneNo) {
    return this.firestore
      .collection('CallUsers', (ref) =>
        ref.where('customerCellphone', '==', phoneNo)
      )
      .get();
  }

  updateProfile(userID, updatedProfile) {
    return this.firestore
      .collection('Users')
      .doc(userID)
      .update({
        ...updatedProfile,
      });
  }

  uploadWallet(userID, rands) {
    const db = firebase.firestore();
    const walletRef = db.collection(`Users/${userID}/Wallet`).doc('wallet');
    const increment = firebase.firestore.FieldValue.increment(rands);
    return walletRef.update({ rands: increment });
  }

  useWallet(userID, rands) {
    const db = firebase.firestore();
    const walletRef = db.collection(`Users/${userID}/Wallet`).doc('wallet');
    const increment = firebase.firestore.FieldValue.increment(-rands);
    return walletRef.update({ rands: increment });
  }

  getUserWallet(userID) {
    return this.firestore
      .collection(`Users/${userID}/Wallet`)
      .doc('wallet')
      .get();
  }

  createUserRefNo(userID, prefix) {
    const db = firebase.firestore();
    const userRefValue = db.collection('Sequence').doc('user-ref');
    const increment = firebase.firestore.FieldValue.increment(1);

    return userRefValue.update({ value: increment }).then(() =>
      this.firestore
        .collection('Sequence')
        .doc('user-ref')
        .get()
        .pipe(take(1))
        .subscribe((res: any) => {
          const data = res.data();
          const userRefNo = prefix + data.value;

          return this.firestore
            .collection(`Users/${userID}/Ref`)
            .doc('ref')
            .set({
              userRefNo,
            });
        })
    );
  }

  getUserRefNo(userID) {
    return this.firestore.collection(`Users/${userID}/Ref`).doc('ref').get();
  }
}
